import React, { useState, useEffect, useRef } from "react";
import "./ClientsPage.css";

/* ── Client Logo Imports ── */
import dupont      from "../../Assets/Images/dupont.png";
import iff         from "../../Assets/Images/iff.png";
import tcs         from "../../Assets/Images/tcs.png";
import doselect    from "../../Assets/Images/doselect.png";
import recoup      from "../../Assets/Images/recoup.png";
import naukri      from "../../Assets/Images/naukri.png";
import framesbuy   from "../../Assets/Images/framesbuy.png";
// import ambitionbox from "../../Assets/Images/ambitionbox.png";
import piaggio     from "../../Assets/Images/piaggio.png";
// import regalix     from "../../Assets/Images/regalix.png";
// import naukri01     from "../../Assets/Images/naukri01.png";
import ador        from "../../Assets/Images/ador.png";
// import ettmt       from "../../Assets/Images/ettmt.png";
import kirloskar      from "../../Assets/Images/kirloskar.png";
import forbe    from "../../Assets/Images/forbe.png";
import electrotherm    from "../../Assets/Images/electrotherm.png";
import Yobykes    from "../../Assets/Images/yobykescolor.png";
import vasuki    from "../../Assets/Images/vasuki.png";
import aera    from "../../Assets/Images/aera.png";
import balaji    from "../../Assets/Images/balaji.png";
import floret    from "../../Assets/Images/floret.png";
import krupa    from "../../Assets/Images/krupa.png";
import assemble    from "../../Assets/Images/assemble.png";
import leif    from "../../Assets/Images/leif.png";
import zvky    from "../../Assets/Images/zvky.png";
import dde    from "../../Assets/Images/dde.png";
import iimjobs    from "../../Assets/Images/iimjobs.png";
import packtime    from "../../Assets/Images/packtime.png";

/* ══════════════════════════════════════════════════════════
   SERVICES
   Each service has categories.
   Each category has a subRange: which sub-indices belong to it.
   Client services map: { serviceIndex: [subIndex, ...] }
   We derive which categories are active by checking if any
   of the client's subIndices fall within a category's subRange.
══════════════════════════════════════════════════════════ */
const SERVICES = [
  {
    label: "Branding & Design",
    categories: [
      { name: "Brand Strategy",                 subRange: [0,  4]  },
      { name: "Brand Identity",          subRange: [5,  9]  },
      { name: "Corporate Communication", subRange: [10, 14] },
      { name: "Marketing & Creative",    subRange: [15, 19] },
      { name: "UI/UX",                   subRange: [20, 24] },
    ],
  },
  {
    label: "Animation",
    categories: [
      { name: "2D/3D Animation",             subRange: [0,  4]  },
      { name: "3D Animation",             subRange: [5,  9]  },
      { name: "Character & Storytelling", subRange: [10, 14] },
      { name: "Motion Design",            subRange: [15, 19] },
    ],
  },
  {
    label: "3D Product Visualization",
    categories: [
      { name: "Product Rendering",               subRange: [0,  4]  },
      { name: "Industrial Visualization",        subRange: [5,  9]  },
      { name: "Interactive 3D",                  subRange: [10, 13] },
      { name: "Architectural & Spatial",         subRange: [14, 17] },
      { name: "Character Asset Creation",        subRange: [18, 22] },
      { name: "Environment & Set Development",   subRange: [23, 27] },
      { name: "Prop & Production Assets",        subRange: [28, 32] },
      { name: "Look Development",                subRange: [33, 37] },
    ],
  },
  {
    label: "Visual Production",
    categories: [
      { name: "Video Production",      subRange: [0,  4]  },
      { name: "Commercial Production", subRange: [5,  8]  },
      // { name: "Photography",           subRange: [9,  12] },
      { name: "Post Production",       subRange: [13, 17] },
    ],
  },
  {
    label: "Web Development",
    categories: [
      { name: "Website & Applications",   subRange: [0,  4]  },
      { name: "E-Commerce",            subRange: [5,  8]  },
      { name: "Web Applications",      subRange: [9,  12] },
      { name: "Frontend & Experience", subRange: [13, 16] },
      { name: "Maintenance & Support", subRange: [17, 20] },
    ],
  },
  {
    label: "Digital Marketing",
    categories: [
      { name: "Performance",   subRange: [0,  4]  },
      { name: "Social Media",  subRange: [5,  8]  },
      { name: "SEO", subRange: [9,  13] },
      { name: "Branding Campaigns",      subRange: [14, 17] },
      { name: "Analytics & Automation",  subRange: [18, 21] },
    ],
  },
  {
    label: "Exhibition",
    categories: [
      { name: "Exhibition Stall Design",  subRange: [0,  3]  },
      { name: "3D & Visualization",       subRange: [4,  6]  },
      { name: "Fabrication & Execution",  subRange: [7,  10] },
      { name: "Event Branding",           subRange: [11, 14] },
      { name: "Interactive Experiences",  subRange: [15, 18] },
    ],
  },
];

/* ── Helper: given a client's subIndex array for a service,
   return which category names are active ── */
function getActiveCategories(categories, subIndices) {
  if (!subIndices || subIndices.length === 0) return [];
  return categories
    .filter(cat =>
      subIndices.some(idx => idx >= cat.subRange[0] && idx <= cat.subRange[1])
    )
    .map(cat => cat.name);
}

/* ══════════════════════════════════════════════════════════
   CLIENTS
   services: { serviceIndex: [subIndex, ...] }
══════════════════════════════════════════════════════════ */
const CLIENTS = [
  {
    name: "Kirloskar", logo: kirloskar,
    services: {
      0: [15], 1: [0, 10, 15], 2: [0, 6], 3: [0, 9, 13],
    },
  },
 {
    name: "Forbes Marshall", logo: forbe,
    services: { 0: [15], 1: [0, 5, 15], 2: [0, 5] },
  },
 
    {
    name: "Yobykes", logo: Yobykes,
    services: {
      0: [0, 5, 15, 20], 1: [0, 10, 15], 2: [0, 5, 10],
      3: [0, 9, 13], 4: [0, 17], 5: [0, 5, 9, 14], 6: [0, 4, 11],
    },
  },
  {
    name: "Vasuki Cement", logo: vasuki,
    services: {
      0: [0, 5, 15, 20], 1: [5, 15], 2: [0, 10],
      4: [0, 17], 5: [0, 5, 9],
    },
  },
  {
    name: "Electrotherm", logo: electrotherm,
    services: {
      0: [0, 5,  15, 20], 1: [0, 15], 2: [0, 5],
      3: [0, 9, 13], 4: [0, 17], 5: [0, 5, 9], 6: [11],
    },
  },
  {
    name: "Ador", logo: ador,
    services: {
      0: [10, 15, 20], 1: [0, 5], 2: [0, 10],
      3: [0, 9], 4: [0, 13],
    },
  },
  {
    name: "DDE", logo: dde,
    services: { 1: [5, 15], 2: [0, 5, 10], 3: [9, 13], 6: [15] },
  },
  {
    name: "Recoup Health", logo: recoup,
    services: {
      0: [0, 5, 15, 20], 1: [0, 10],
      3: [0], 4: [0, 17], 6: [11],
    },
  },

  {
    name: "DuPont", logo: dupont,
    services: { 0: [15], 1: [0, 15] },
  },
    {
    name: "Packtime", logo: packtime,
    services: { 1: [5, 15], 2: [0], 3: [0, 9, 13], 6: [0, 4] },
  },
  {
    name: "IFF", logo: iff,
    services: { 0: [15], 1: [0, 5, 15] },
  },
  {
    name: "TCS", logo: tcs,
    services: { 0: [10, 15], 1: [0, 15], 3: [0, 13] },
  },
  {
    name: "Naukri", logo: naukri,
    services: { 0: [10, 15], 1: [0, 15] },
  },
  {
    name: "Aera Technology", logo: aera,
    services: { 1: [0] },
  },
  {
    name: "Piaggio", logo: piaggio,
    services: { 1: [5, 15], 2: [0], 3: [13] },
  },
  {
    name: "Balaji Blossoms", logo: balaji,
    services: { 0: [5, 15, 20], 3: [0, 9], 4: [0, 17], 6: [0, 4,11] },
  },
  {
    name: "Krupa Florals", logo: krupa,
    services: { 0: [5, 15, 20], 3: [0, 9, 13], 4: [0, 17], 6: [0, 4, 11] },
  },
  {
    name: "Floret", logo: floret,
    services: { 0: [0, 5, 15, 20], 3: [0], 4: [0, 17], 6: [0, 4, 11] },
  },
  {
    name: "Assemblage", logo: assemble,
    services: { 2: [18, 23] },
  },
  {
    name: "Leif", logo: leif,
    services: { 2: [18] },
  },
  {
    name: "Zvky Design", logo: zvky,
    services: { 1: [5] },
  },
  {
    name: "Framesbuy", logo: framesbuy,
    services: { 2: [0] },
  },
  {
    name: "DoSelect", logo: doselect,
    services: { 0: [10, 15], 1: [0] },
  },
   {
    name: "Iimjobs", logo: iimjobs,
    services: { 0: [10, 15], 1: [0, 15]  },
  },
];

const AUTOPLAY_DELAY = 3000;

export default function ClientsPage() {
  const [activeClient, setActiveClient] = useState(0);
  const [isHovering,   setIsHovering]   = useState(false);

  const autoplayRef  = useRef(null);
  const resumeRef    = useRef(null);
  const currentIndex = useRef(0);
  const servicesRef  = useRef(null);

  const startAutoplay = (fromIndex) => {
    stopAutoplay();
    currentIndex.current = fromIndex;
    autoplayRef.current = setInterval(() => {
      currentIndex.current = (currentIndex.current + 1) % CLIENTS.length;
      setActiveClient(currentIndex.current);
    }, AUTOPLAY_DELAY);
  };

  const stopAutoplay = () => {
    if (autoplayRef.current) { clearInterval(autoplayRef.current); autoplayRef.current = null; }
  };

  const stopResume = () => {
    if (resumeRef.current) { clearTimeout(resumeRef.current); resumeRef.current = null; }
  };

  useEffect(() => {
    startAutoplay(0);
    return () => { stopAutoplay(); stopResume(); };
  }, []);

  const handleMouseEnter = (i) => {
    stopAutoplay();
    stopResume();
    setIsHovering(true);
    setActiveClient(i);
    currentIndex.current = i;
  };

  /* Handles tap on mobile/tablet — reuses the same selection logic as
     hover, then scrolls the services panel into view since it sits
     above the client list once the layout stacks. */
  const handleClientSelect = (i) => {
    handleMouseEnter(i);
    if (window.matchMedia("(max-width: 1100px)").matches && servicesRef.current) {
      servicesRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    resumeRef.current = setTimeout(() => {
      startAutoplay(currentIndex.current);
    }, AUTOPLAY_DELAY);
  };

  const activeMap = CLIENTS[activeClient].services;
  const isServiceActive = (si) => activeMap[si] !== undefined;

  return (
    <div className="clients-page">

      {/* ── Hero ── */}
      <section className="client-section-hero">
        <div className="hero-container">
         
          <div className="focus-outer">
            <div className="focus-label-row">
              <span className="focus-label-text">Structured Partnerships. Reliable Execution.</span>
            </div>
            <div className="focus-box">
              <p className="focus-box-copy">
                Built for businesses that value creativity, clarity, consistency, <br/>and execution discipline.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Main Section ── */}
      <section className="clients-section">
        <div className="clients-container">

          {/* ── LEFT — Client Logo Grid ── */}
          <div className="clients-left">
            <div className="clients-logo-grid-scroll">
              <div className="clients-logo-grid">
                {CLIENTS.map((client, i) => (
                  <div
                    key={i}
                    className={`client-logo-card${activeClient === i ? " client-logo-card--active" : ""}`}
                    onMouseEnter={() => handleMouseEnter(i)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => handleClientSelect(i)}
                  >
                    <img src={client.logo} alt={client.name} className="client-logo-img" />
                  </div>
                ))}
              </div>
            </div>
            <p className="clients-hint"></p>
          </div>

          {/* ── RIGHT — Services Panel ── */}
          <div className="clients-right" ref={servicesRef}>
            <div className="services-title">Services Delivered</div>
            <div className="services-panel">
              {SERVICES.map((svc, si) => {
                const isActive       = isServiceActive(si);
                const subIndices     = activeMap[si] || [];
                const activeCategories = getActiveCategories(svc.categories, subIndices);

                return (
                  <div
                    key={si}
                    className={`svc-row${isActive ? " svc-row--active" : ""}`}
                  >
                    <span className={`svc-row-label${isActive ? " svc-row-label--active" : ""}`}>
                      {svc.label}
                    </span>
                    {isActive && activeCategories.length > 0 && (
                      <span className="svc-row-sub">
                        {activeCategories.join(" | ")}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}